/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 24/3/25.
 */

import config from "@/config";

export default async function () {
  try {
	  return (await import(`./${config.ORIGIN.toLowerCase()}/SessionManager.js`)).default;
  } catch (error) {
    console.error('Failed to load session manager:', error);
    throw error;
  }
}
